import { APIEndpoints } from '@/constants'
import type { Models } from '@/types'
import { sendRequest } from '@/utils'

export const fetchISESegmentMappingTemplates = async (
  endpoint: string,
  productId: string,
  token: string,
): Promise<IISESegmentMapGetTemplateResponse | null> => {
  const path = 'product/config'
  const query = new URLSearchParams({
    productName: productId,
  })
  const response = await fetch(`${endpoint}/${path}?${String(query)}`, {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    console.error('Error fetching field mapping template.')
    return null
  }

  return await response.json()
}

export const fetchSegmentMappingConfig = async (
  endpoint: string,
  accountId: string,
  token: string,
): Promise<IISESegmentMapGetConfigResponse | null> => {
  const productId = 'ise_srp_import_segmentation'
  const path = `account/products/${accountId}/${productId}`
  const response = await fetch(`${endpoint}/${path}`, {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    console.error('Error fetching field feed options.')
    return null
  }

  return await response.json()
}

export namespace SegmentService {
  export async function getSegments(accountId: string, productId: string, token: string) {
    accountId = 'USGAEDV6376001'
    return await sendRequest<{
      Enable: boolean
      segments: {
        config: Array<Partial<Models.Segment>>
      }
    }>({
      url: APIEndpoints.GET_SEGMENTS(accountId, productId),
      method: 'GET',
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
  }

  export async function saveSegments(segments: Array<Models.Segment>) {
    const data = {
      config: {
        segments: {
          config: segments,
        },
      },
    }
    return await sendRequest<string>({
      url: APIEndpoints.SAVE_SEGMENTS(),
      method: 'PUT',
      data,
    })
  }
}
